import {Selector} from '@ngxs/store';
import {IGroup} from '@interfaces/group';
import {ModalsState} from '@store/modals/modals.state';
import {ModalsStateModel} from '@store/modals/modals-state.model';
import {IResponse} from '@interfaces/response';
import {IDevice} from '@interfaces/devices';
import {ISchedule} from '@interfaces/schedule';

export class ModalsSelectors {
  @Selector([ModalsState])
  static getGroups(state: ModalsStateModel): IResponse<IGroup> | null {
    return state.groups;
  }

  @Selector([ModalsState])
  static getDevicesWithoutGroup(state: ModalsStateModel): IResponse<IDevice> | null {
    return state.devicesWithoutGroup;
  }

  @Selector([ModalsState])
  static getDevicesFromGroupToEdit(state: ModalsStateModel): IResponse<IDevice> | null {
    return state.devicesFromGroupToEdit;
  }

  @Selector([ModalsState])
  static getEventToEdit(state: ModalsStateModel): ISchedule | null {
    return state.eventToEdit.event;
  }

  @Selector([ModalsState])
  static getEventDeviceGroupName(state: ModalsStateModel): string {
    return state.eventToEdit.activeEventDeviceGroupName;
  }

  @Selector([ModalsState])
  static getScheduleId(state: ModalsStateModel): number | null {
    return state.eventToEdit.scheduleId;
  }

  @Selector([ModalsState])
  static getEventDescription(state: ModalsStateModel): string {
    return state.eventToEdit.description;
  }
}
